module.exports = __webpack_public_path__ + "img/prj03.8b91021a.png";